
/**
 * @export
 * @enum {string}
 */
export enum GrantStatus {
    ALLOW = 'ALLOW',
    DENY = 'DENY'
}